import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReglasNegocioService {

  constructor() { }

  esConyugeCuidador(validador: any, conyuge: any): boolean {
    if (validador?.afiliado?.estado !== "VIGEN" || validador?.afiliado?.afiliacion?.categoria !== "A") {
      return false;
    }
    if (conyuge?.TipoIdConyuge === "CO1L") {
      return false;
    }
    const pacs = validador?.pacs;
    if (Array.isArray(pacs)) {
      for (let i = 0; i < pacs.length; i++) {
        const pac = pacs[i];
        if (pac?.discapacidad === "1" && pac?.estado === "VIGEN") {
          return true;
        }
      }
    }
    return false;
  }


}
